/**
 * Behavioral Health Data Service
 * Carga datos de BH desde archivos JSON estáticos por location.
 * Usa dynamic import para cargar solo los datos de la location seleccionada.
 *
 * Los JSONs se encuentran en: src/pages/Main/Temp/DataDashBH/
 * Cada location tiene UN archivo: location_{key}.json con TODOS los paneles dentro.
 *
 * Migración futura: Reemplazar imports estáticos por llamadas API.
 */

// Cache de locations (se carga una sola vez)
let locationsCache = null;

/**
 * Obtiene la lista de locations disponibles para BH Dashboard.
 * Normaliza los campos para compatibilidad con LocationSelector (address, patients).
 *
 * @returns {Promise<Array>} Lista de locations
 */
export async function getBHLocations() {
  if (locationsCache) return locationsCache;
  const module = await import(
    "../../../pages/Main/Temp/DataDashBH/locations.json"
  );
  const raw = module.default?.locations || module.locations || [];
  locationsCache = raw.map((loc) => ({
    ...loc,
    label: loc.name || loc.label || "",
    address: loc.fullName || loc.address || "",
    patients: loc.patients ?? 0,
  }));
  return locationsCache;
}

/**
 * Carga TODOS los datos de una location BH desde su JSON unificado.
 * Retorna el objeto completo con todas las secciones de paneles.
 *
 * @param {string} locationKey - Key de la location (e.g., "fort_myers")
 *
 * @returns {Promise<Object>} Objeto con: overview, riskStratification, substanceUse,
 *   erUtilization, unmanagedPatients, carePrograms, taskStats
 */
export async function getBHLocationData(locationKey) {
  const module = await import(
    `../../../pages/Main/Temp/DataDashBH/location_${locationKey}.json`
  );
  const data = module.default || module;
  return {
    overview: data.overview || null,
    riskStratification: data.riskStratification || null,
    substanceUse: data.substanceUse || null,
    erUtilization: data.erUtilization || null,
    unmanagedPatients: data.unmanagedPatients || null,
    carePrograms: data.carePrograms || null,
    taskStats: data.taskStats || null,
  };
}
